export default {
    recordTabChange() {
        window.ga && window.ga('send', 'pageview');
    },

    recordHelpTextView(helpTextName) {
        window.ga && window.ga('send', 'event', 'HelpTextViewed', helpTextName);
    },

    recordEmbedCopy() {
        window.ga && window.ga('send', 'event', 'EmbedCopy');
    }
};
